// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    position: relative;
    height: 100px;
    box-shadow: 1px 2px 4px -1px rgba(0,0,0,0.18);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 52px;
    z-index: 9999;
}

.header_row {
    display: flex;
    align-items: center;
}


.user-container-header {
    position: relative;
    min-width: 200px;
    cursor: pointer;
}

.header_logo {
    height: 100%;
}

.user-image-header {
    width: 50px;
    height: 50px;
    background-size: cover;
    border-radius: 50%;
    margin-right: 20px;
}



.user-name-header {
    margin-right: 20px;
    font-size: 14px;
    font-weight: 600;
}

.user-arrow-show {
    display: flex;
    transition: 0.3s;
}

.user-arrow-hide {
    transform: rotateZ(180deg);
    transition: 0.3s;
}

.user-menu-header {
    background: #ffffff;
    min-width: 200px;
    position: absolute;
    right: 5%;
    top: -27%;
    transform: translateY(80px);
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);
    border-radius: 5px;
    z-index: 2;
}

.support-menu-header {
    background: #ffffff;
    min-width: 200px;
    position: absolute;
    right: 60%;
    top: -27%;
    transform: translateY(80px);
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);
    border-radius: 5px;
    z-index: 2;
}

.header-support-menu-item {
    width: 34px;
    margin-right: 14px;
    cursor: pointer;
    padding: 4px;
    margin-bottom: -3px;
}

.hide-menu {
    display: none;
}

.header-user-menu-item {
    width: 100%;
    height: 45px;
    padding-left: 15px;
    font-weight: 600;
    border-bottom: 1px solid #efecec;
    cursor: pointer;

}

.header-user-menu-item > p {
    font-size: 12px;
    font-weight: lighter;
}

div.header_search.search_container {
    margin-left: 15px;
}

/* BURGER MENU */

.burger_menu {
    width: 24px;
    height: 15px;
    margin-left: 30px;
    margin-right: 23px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    transition: width 0.20s;
}

.burger_menu:hover{
    width: 30px;
}

.burger_line {
    width: 100%;
    height: 3px;
    background-color: #242424;
    transition: 0.3s;
}
.burger_line_close {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    height: 3px;
    background-color: #242424;
    transition:  0.20s;
}


/* NOTIFICATION BUTTON */
.header_notification {
    height: 24px;
    width: 24px;
    margin-right: 14px;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}
.header_notification > img{
    width: 22px;
    position: relative;
    z-index: 10;
}
.notification_dot {
    min-width: 25px;
    min-height: 25px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: 700;
    font-size: 13px;
    position: absolute;
    right: -15px;
    top: -15px;
    background-color: #fe5f55;
}

.notification_menu {
    position: absolute;
    width: 400px;
    padding: 15px;
    height: max-content;
    background-color: white;
    right: 0;
    top: 26px;
    box-shadow: rgba(149, 157, 165, 0.4) 0 8px 24px;
    border-radius: 5px;
}

.header_update_item {
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
}

.header_update_item > p {
    margin-left: 10px;
    font-size: 12px;
}

.notification_menu_view_all {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    color: #1EC0A6;
    cursor: pointer;
}

@media (max-width: 1000px) {
    /* SHOW SEARCH */
    .header_search_responsive_show {
        min-width: 400px;
        width: max-content;
        max-width: 80vw;
        height: 45px;
        margin-left: 15px;
        border-radius: 10px;
        background-color: #EDEEF4;
        display: flex;
        transition: 0.3s;
    }
    .header_search_responsive_show > input {
        width: 100%;
        -webkit-appearance: none;
        border: none;
        background-color: transparent;
        font-size: 14px;
        padding-left: 15px;
        color: rgba(124, 130, 138, 1);
    }
    .header_search_responsive_show > input::placeholder {
        color: rgba(124, 130, 138, 0.38);
    }
    /* HIDE SEARCH */
    .header_search_responsive_hide {
        width: 45px;
        height: 45px;
        margin-left: 15px;
        border-radius: 10px;
        background-color: #EDEEF4;
        display: flex;
        transition: 0.3s;
    }
    .header_search_responsive_hide > input {
        display: none;
    }
    .header_row :first-child { order: 2 }
    .header_row :nth-child(2) { order: 1 }
    .header_row :last-child { order: 3 }
}

@media (max-width: 615px) {
    .user-name-header {
        display: none;
    }
    .user-container-header {
        min-width: 50px;
    }
    .burger_menu {
        margin-left: 20px;
        margin-right: 0;
    }
    .header_notification {
        margin-right: 25px;
    }
}

@media (max-width: 400px) {
    .header_search_responsive_show {
        max-width: 70vw;
    }
    .header_logo {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/HeaderComponentWithUser.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IAEb,6CAA6C;IAC7C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;;;AAIA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAG3B,yCAAyC;IACzC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAG3B,yCAAyC;IACzC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,gBAAgB;;AAEhB;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;;AAGA,wBAAwB;AACxB;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,SAAS;IAET,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB;QACI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,yBAAyB;QACzB,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,wBAAwB;QACxB,YAAY;QACZ,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;QAClB,6BAA6B;IACjC;IACA;QACI,gCAAgC;IACpC;IACA,gBAAgB;IAChB;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,yBAAyB;QACzB,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA,2BAA2B,SAAS;IACpC,4BAA4B,SAAS;IACrC,0BAA0B,SAAS;AACvC;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".header {\n    position: relative;\n    height: 100px;\n    -webkit-box-shadow: 1px 2px 4px -1px rgba(0,0,0,0.18);\n    box-shadow: 1px 2px 4px -1px rgba(0,0,0,0.18);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-right: 52px;\n    z-index: 9999;\n}\n\n.header_row {\n    display: flex;\n    align-items: center;\n}\n\n\n.user-container-header {\n    position: relative;\n    min-width: 200px;\n    cursor: pointer;\n}\n\n.header_logo {\n    height: 100%;\n}\n\n.user-image-header {\n    width: 50px;\n    height: 50px;\n    background-size: cover;\n    border-radius: 50%;\n    margin-right: 20px;\n}\n\n\n\n.user-name-header {\n    margin-right: 20px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.user-arrow-show {\n    display: flex;\n    transition: 0.3s;\n}\n\n.user-arrow-hide {\n    transform: rotateZ(180deg);\n    transition: 0.3s;\n}\n\n.user-menu-header {\n    background: #ffffff;\n    min-width: 200px;\n    position: absolute;\n    right: 5%;\n    top: -27%;\n    transform: translateY(80px);\n    -webkit-box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    -moz-box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    border-radius: 5px;\n    z-index: 2;\n}\n\n.support-menu-header {\n    background: #ffffff;\n    min-width: 200px;\n    position: absolute;\n    right: 60%;\n    top: -27%;\n    transform: translateY(80px);\n    -webkit-box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    -moz-box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    border-radius: 5px;\n    z-index: 2;\n}\n\n.header-support-menu-item {\n    width: 34px;\n    margin-right: 14px;\n    cursor: pointer;\n    padding: 4px;\n    margin-bottom: -3px;\n}\n\n.hide-menu {\n    display: none;\n}\n\n.header-user-menu-item {\n    width: 100%;\n    height: 45px;\n    padding-left: 15px;\n    font-weight: 600;\n    border-bottom: 1px solid #efecec;\n    cursor: pointer;\n\n}\n\n.header-user-menu-item > p {\n    font-size: 12px;\n    font-weight: lighter;\n}\n\ndiv.header_search.search_container {\n    margin-left: 15px;\n}\n\n/* BURGER MENU */\n\n.burger_menu {\n    width: 24px;\n    height: 15px;\n    margin-left: 30px;\n    margin-right: 23px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    cursor: pointer;\n    transition: width 0.20s;\n}\n\n.burger_menu:hover{\n    width: 30px;\n}\n\n.burger_line {\n    width: 100%;\n    height: 3px;\n    background-color: #242424;\n    transition: 0.3s;\n}\n.burger_line_close {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto;\n    height: 3px;\n    background-color: #242424;\n    transition:  0.20s;\n}\n\n\n/* NOTIFICATION BUTTON */\n.header_notification {\n    height: 24px;\n    width: 24px;\n    margin-right: 14px;\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.header_notification > img{\n    width: 22px;\n    position: relative;\n    z-index: 10;\n}\n.notification_dot {\n    min-width: 25px;\n    min-height: 25px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-weight: 700;\n    font-size: 13px;\n    position: absolute;\n    right: -15px;\n    top: -15px;\n    background-color: #fe5f55;\n}\n\n.notification_menu {\n    position: absolute;\n    width: 400px;\n    padding: 15px;\n    height: max-content;\n    background-color: white;\n    right: 0;\n    top: 26px;\n    -webkit-box-shadow: rgba(149, 157, 165, 0.4) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.4) 0 8px 24px;\n    border-radius: 5px;\n}\n\n.header_update_item {\n    display: flex;\n    align-items: center;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.header_update_item > p {\n    margin-left: 10px;\n    font-size: 12px;\n}\n\n.notification_menu_view_all {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 600;\n    color: #1EC0A6;\n    cursor: pointer;\n}\n\n@media (max-width: 1000px) {\n    /* SHOW SEARCH */\n    .header_search_responsive_show {\n        min-width: 400px;\n        width: max-content;\n        max-width: 80vw;\n        height: 45px;\n        margin-left: 15px;\n        border-radius: 10px;\n        background-color: #EDEEF4;\n        display: flex;\n        transition: 0.3s;\n    }\n    .header_search_responsive_show > input {\n        width: 100%;\n        -webkit-appearance: none;\n        border: none;\n        background-color: transparent;\n        font-size: 14px;\n        padding-left: 15px;\n        color: rgba(124, 130, 138, 1);\n    }\n    .header_search_responsive_show > input::placeholder {\n        color: rgba(124, 130, 138, 0.38);\n    }\n    /* HIDE SEARCH */\n    .header_search_responsive_hide {\n        width: 45px;\n        height: 45px;\n        margin-left: 15px;\n        border-radius: 10px;\n        background-color: #EDEEF4;\n        display: flex;\n        transition: 0.3s;\n    }\n    .header_search_responsive_hide > input {\n        display: none;\n    }\n    .header_row :first-child { order: 2 }\n    .header_row :nth-child(2) { order: 1 }\n    .header_row :last-child { order: 3 }\n}\n\n@media (max-width: 615px) {\n    .user-name-header {\n        display: none;\n    }\n    .user-container-header {\n        min-width: 50px;\n    }\n    .burger_menu {\n        margin-left: 20px;\n        margin-right: 0;\n    }\n    .header_notification {\n        margin-right: 25px;\n    }\n}\n\n@media (max-width: 400px) {\n    .header_search_responsive_show {\n        max-width: 70vw;\n    }\n    .header_logo {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
